export { Collapsible, CollapsibleContent, CollapsibleTrigger } from "ics-ui-kit/components/collapsible";
export { CollapsiblePreview } from "./CollapsiblePreview";
